<template>
<!-- <row a="start" j="between" w>
    <h1>I'll be aligned</h1>
    <p>at the start and justified between</p>
</row> -->
    <div class="flex column" :class="`align-${a} ${j} ${s && 'v-scroll fit' || ''}`"><slot /></div>
</template>
<script>
    export default {
        name: 'row',
        props:{
            a: {type: String, default: 'center'},
            j: {type: String, default: ''},
            s: {type: Boolean, default: false}
        }
    }
</script>